import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import {
  Button,
  CreateTransactionModal,
  CreationExitModal,
  PhaseKpis,
  ToolsDrawer,
  UserActionsPhases,
} from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import { Prompt, useHistory, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { generateMessageError, isUserAllowed, sendUserDataToGTM } from 'modules/core/utils'
import { CONCEPTS, PROJECTION, ROLES } from 'modules/core/constants'
import {
  handleDeleteSelection,
  renderButtonSendName,
  renderFunctionSend,
} from 'modules/core/components/ProjectionComponents/utils'
import { Col, message, notification, Row } from 'antd'
import { CreateBudgetModal } from 'modules/planning/components'
import { GENERAL } from '../../../../../core/constants'
import { handleDeleteAll } from './utils'
import { FiltersSlidersKpis, TabsTables } from './components'
import planning from 'modules/planning'
import configuration from 'modules/configuration'
import home from 'modules/home'
import login from 'modules/login'
import _ from 'lodash'

import './BaseBudget.scss'
import { useDefaultCurrency } from 'modules/core/customHooks'
import PropTypes from 'prop-types'
import control from 'modules/control'

const {
  PLANNING__SALES__BASE__ABM,
  PLANNING__SALES__TOP_DOWN__ABM,
  PLANNING__SALES__BOTTOM_UP__ABM,
  PLANNING__SALES__CLOSING__ABM,
  PLANNING__EXPENSES__BASE__ABM,
  PLANNING__EXPENSES__TOP_DOWN__ABM,
  PLANNING__EXPENSES__BOTTOM_UP__ABM,
  PLANNING__EXPENSES__CLOSING__ABM,
  PLANNING__COSTS__BASE__ABM,
  PLANNING__COSTS__TOP_DOWN__ABM,
  PLANNING__COSTS__BOTTOM_UP__ABM,
  PLANNING__COSTS__CLOSING__ABM,
  PLANNING__HUMAN_RESOURCES__BASE__ABM,
  PLANNING__HUMAN_RESOURCES__TOP_DOWN__ABM,
  PLANNING__HUMAN_RESOURCES__BOTTOM_UP__ABM,
  PLANNING__HUMAN_RESOURCES__CLOSING__ABM,
  PLANNING__OTHER_5__BASE__ABM,
  PLANNING__OTHER_5__TOP_DOWN__ABM,
  PLANNING__OTHER_5__BOTTOM_UP__ABM,
  PLANNING__OTHER_5__CLOSING__ABM,
  PLANNING__OTHER_6__BASE__ABM,
  PLANNING__OTHER_6__TOP_DOWN__ABM,
  PLANNING__OTHER_6__BOTTOM_UP__ABM,
  PLANNING__OTHER_6__CLOSING__ABM,
  PLANNING__OTHER_7__BASE__ABM,
  PLANNING__OTHER_7__TOP_DOWN__ABM,
  PLANNING__OTHER_7__BOTTOM_UP__ABM,
  PLANNING__OTHER_7__CLOSING__ABM,
  PLANNING__OTHER_8__BASE__ABM,
  PLANNING__OTHER_8__TOP_DOWN__ABM,
  PLANNING__OTHER_8__BOTTOM_UP__ABM,
  PLANNING__OTHER_8__CLOSING__ABM,
} = ROLES

const PLANNING__CONCEPT = {
  AMB: {
    [CONCEPTS.IDS.SALES_ID]: {
      [PROJECTION.BASE]: PLANNING__SALES__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__SALES__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__SALES__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__SALES__CLOSING__ABM,
    },
    [CONCEPTS.IDS.EXPENSES_ID]: {
      [PROJECTION.BASE]: PLANNING__EXPENSES__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__EXPENSES__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__EXPENSES__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__EXPENSES__CLOSING__ABM,
    },
    [CONCEPTS.IDS.COSTS_ID]: {
      [PROJECTION.BASE]: PLANNING__COSTS__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__COSTS__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__COSTS__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__COSTS__CLOSING__ABM,
    },
    [CONCEPTS.IDS.HUMAN_RESOURCES_ID]: {
      [PROJECTION.BASE]: PLANNING__HUMAN_RESOURCES__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__HUMAN_RESOURCES__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__HUMAN_RESOURCES__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__HUMAN_RESOURCES__CLOSING__ABM,
    },
    [CONCEPTS.IDS.OTHER_5_ID]: {
      [PROJECTION.BASE]: PLANNING__OTHER_5__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__OTHER_5__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__OTHER_5__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__OTHER_5__CLOSING__ABM,
    },
    [CONCEPTS.IDS.OTHER_6_ID]: {
      [PROJECTION.BASE]: PLANNING__OTHER_6__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__OTHER_6__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__OTHER_6__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__OTHER_6__CLOSING__ABM,
    },
    [CONCEPTS.IDS.OTHER_7_ID]: {
      [PROJECTION.BASE]: PLANNING__OTHER_7__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__OTHER_7__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__OTHER_7__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__OTHER_7__CLOSING__ABM,
    },
    [CONCEPTS.IDS.OTHER_8_ID]: {
      [PROJECTION.BASE]: PLANNING__OTHER_8__BASE__ABM,
      [PROJECTION.TOPDOWN]: PLANNING__OTHER_8__TOP_DOWN__ABM,
      [PROJECTION.BOTTOMUP]: PLANNING__OTHER_8__BOTTOM_UP__ABM,
      [PROJECTION.CLOSING]: PLANNING__OTHER_8__CLOSING__ABM,
    },
  },
}

const BaseBudget = ({
  budgetInstanceDetail,
  dataPhase,
  onRefetch,
  status_budget,
  tablePagination,
  fetchBudgetKpis,
  budgetKPIS,
  setNextPhase,
  closingBudget,
  fetchBudgetInstanceList,
  updateBudgetInstance,
  budgetInstanceList,
  periodList,
  fetchDataNestedTableByPhase,
  uploadSpreadsheets,
  applyBudgetRule,
  unApplyBudgetRule,
  massiveCreatePlanningTransaction,
  fetchAllDimensions,
  fetchDataRdnPercentageByPlanning,
  fetchRulesList,
  deleteAllTransaction,
  loggedUser,
  fetchCommentsList,
  commentsList,
  uploadPlanningExcelFileBy,
  allDimensionsList,
  setFiltersSliders,
  showTableqp,
  setShowTableqp,
  applyUnappluMassivePlanning,
  shareLayout,
}) => {
  const extraConcept = useFeatureIsOn('feature-extra-concept')
  const enableSliders = useFeatureIsOn('ab_planning_sliders')
  const enableKpis = useFeatureIsOn('feature-visible-kpi')
  const [showPopConfirmSend, setShowPopConfirmSend] = useState(false)
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [isKpisLoading, setIsKpisLoading] = useState(false)
  const [isTableNestedLoading, setIsTableNestedLoading] = useState(false)
  const [showDrawerTools, setShowDrawerTools] = useState(false)
  const [showDeleteAll, setShowDeleteAll] = useState(false)
  const [isDeletingAll, setIsDeletingAll] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [value, setValue] = useState(PROJECTION.TYPE_UPLOAD_OPTION_DEFAULT)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [applyRule, setApplyRule] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [ruleTypeValue, setRuleTypeValue] = useState(null)
  const [sliderValue, setSliderValue] = useState({
    price_percentage_increase: 0,
    quantity_percentage_increase: 0,
    amount_percentage_increase: 0,
  })
  const [selectedDates, setSelectedDates] = useState({})
  const [filters, setFilters] = useState({})
  const [dataDimensions, setDataDimensions] = useState([])
  const [isSaving, setIsSaving] = useState(false)
  const [showAlert, setShowAlert] = useState({
    transactional: false,
    kpi: false,
    percentage: false,
    createTransaction: false,
    send: false,
    rule: false,
    create: false,
  })
  const [showExitModal, setShowExitModal] = useState(false)
  const [lastLocation, setLastLocation] = useState(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const [settingsNested, setSettingsNested] = useState({})
  const [settingsPercentage, setSettingsPercentage] = useState({})
  const defaultCurrencyData = useDefaultCurrency()

  let { budgetId, periodId, tab } = useParams()
  let history = useHistory()
  const { t } = useTranslation()

  const [tabKey, setTabKey] = useState(tab || PROJECTION.PLANNING_KEYS.TRANSACTIONAL_KEY)
  const [businessRuleId, setBusinessRuleId] = useState(null)

  const key = window.location.pathname.replaceAll('/', '-')

  let queryString = window.location.search
  let urlParams = new URLSearchParams(queryString)
  let rule = urlParams.get('rule')

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault()
      window.confirm('Puede que haya cambios sin guardar, deseas volver atrás?')
    }

    if (
      showAlert.transactional ||
      showAlert.kpi ||
      showAlert.percentage ||
      showAlert.createTransaction ||
      showAlert.send ||
      showAlert.rule ||
      showAlert.create
    ) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    if (
      !showAlert.transactional &&
      !showAlert.kpi &&
      !showAlert.percentage &&
      !showAlert.createTransaction &&
      !showAlert.send &&
      !showAlert.rule &&
      !showAlert.create
    ) {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [
    showAlert.kpi,
    showAlert.transactional,
    showAlert.percentage,
    showAlert.createTransaction,
    showAlert.send,
    showAlert.rule,
    showAlert.create,
  ])

  useEffect(() => {
    setIsLoading(true)
    fetchCommentsList({ module: `${key}-${dataPhase.key}` }).then(() => setIsLoading(false))
  }, [fetchCommentsList, key, dataPhase.key])

  useEffect(() => {
    setData(commentsList)
  }, [commentsList])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions, periodId])

  useEffect(() => {
    if (allDimensionsList.length > 0 && enableSliders) {
      const dataa = allDimensionsList.map((el) => {
        return {
          ...el,
          values: [],
        }
      })
      setDataDimensions(dataa)
    }
  }, [allDimensionsList, enableSliders])

  useEffect(() => {
    if (!_.isEmpty(budgetInstanceDetail)) {
      setIsKpisLoading(true)
      fetchBudgetKpis({ step: dataPhase.key, planning_id: budgetId }).then(() =>
        setIsKpisLoading(false),
      )
    }
    return () => setIsKpisLoading(false)
  }, [fetchBudgetKpis, budgetId, dataPhase.key, budgetInstanceDetail])

  useEffect(() => {
    if (tabKey !== PROJECTION.PLANNING_KEYS.TRANSACTIONAL_KEY) return
    if (!_.isEmpty(budgetInstanceDetail)) {
      setIsTableNestedLoading(true)
      setShowProgressBar(true)
      fetchDataNestedTableByPhase({
        step: dataPhase.key,
        period_id: periodId,
        concept_id: budgetInstanceDetail?.concept_id,
        planning_id: budgetId,
        page: tablePagination.page,
      }).then(() => {
        setIsTableNestedLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
    }
    return () => setIsTableNestedLoading(false)
  }, [
    fetchDataNestedTableByPhase,
    budgetId,
    periodId,
    dataPhase.key,
    budgetInstanceDetail,
    tablePagination.page,
    tabKey,
  ])

  useEffect(() => {
    if (tabKey !== PROJECTION.PLANNING_KEYS.PERCENTAGE_KEY) return
    if (!_.isEmpty(budgetInstanceDetail) && businessRuleId) {
      setIsTableNestedLoading(true)
      setShowProgressBar(true)
      fetchDataRdnPercentageByPlanning({
        concept_id: budgetInstanceDetail?.concept_id,
        page: tablePagination.page,
        period_id: periodId,
        planning_id: budgetId,
        step: dataPhase.key,
        business_rule_id: businessRuleId,
      }).then(() => {
        setIsTableNestedLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
    }
    return () => setIsTableNestedLoading(false)
  }, [
    fetchDataRdnPercentageByPlanning,
    budgetId,
    periodId,
    dataPhase.key,
    budgetInstanceDetail,
    tabKey,
    businessRuleId,
  ])

  useEffect(() => {
    fetchRulesList({
      period_id: periodId,
      type: 'planning',
      pk: budgetId,
      status_budget: dataPhase.key,
    }).then((resp) => {
      const result = resp.payload.data
      const sortedRules = result.results
        .filter((el) => el.formula_type === 'individual')
        .sort((a, b) => {
          if (a.isApplied === b.isApplied) {
            return 0
          }
          return a.isApplied ? -1 : 1
        })
      if (!_.isEmpty(sortedRules)) {
        if (rule) {
          setBusinessRuleId(parseInt(rule))
        } else {
          setBusinessRuleId(sortedRules[0].id)
        }
        !ruleTypeValue && setRuleTypeValue(sortedRules[0].type_value)
      }
    })
  }, [fetchRulesList, periodId, budgetId, dataPhase.key, rule, ruleTypeValue])

  const verifyPermission = (instance) => {
    const permission = [
      PROJECTION.GLOBAL_BUDGET.toString(),
      CONCEPTS.IDS.SALES_ID.toString(),
      CONCEPTS.IDS.EXPENSES_ID.toString(),
      CONCEPTS.IDS.COSTS_ID.toString(),
      CONCEPTS.IDS.HUMAN_RESOURCES_ID.toString(),
      CONCEPTS.IDS.OTHER_5_ID.toString(),
      CONCEPTS.IDS.OTHER_6_ID.toString(),
      CONCEPTS.IDS.OTHER_7_ID.toString(),
      CONCEPTS.IDS.OTHER_8_ID.toString(),
    ]
    if (permission.includes(instance?.concept_id.toString())) {
      return isUserAllowed(
        PLANNING__CONCEPT.AMB[instance?.concept_id][
          !_.isEmpty(instance) && instance?.step.toUpperCase()
        ],
      )
    } else if (extraConcept) {
      return true
    }

    return false
  }

  useEffect(() => {
    if (!_.isEmpty(budgetInstanceDetail)) {
      fetchBudgetInstanceList(budgetInstanceDetail?.concept_id, periodId)
    }
  }, [fetchBudgetInstanceList, budgetInstanceDetail, periodId])

  const isFinished = budgetInstanceDetail?.step !== dataPhase.key
  const dataPeriod = periodList.find((el) => el.id === parseInt(periodId))
  const canUserABM = !_.isEmpty(budgetInstanceDetail)
    ? verifyPermission(budgetInstanceDetail)
    : true

  const reloadTableNested = () => {
    setIsTableNestedLoading(true)
    setIsKpisLoading(true)
    setShowProgressBar(true)
    setShowAlert((prevState) => {
      return { ...prevState, kpi: true, transactional: true }
    })
    Promise.all([
      fetchBudgetKpis({ step: dataPhase.key, planning_id: budgetId }),
      fetchDataNestedTableByPhase({
        step: dataPhase.key,
        period_id: periodId,
        concept_id: budgetInstanceDetail?.concept_id,
        planning_id: budgetId,
        page: tablePagination.page,
      }),
    ]).then(() => {
      setIsTableNestedLoading(false)
      setIsKpisLoading(false)
      setShowAlert((prevState) => {
        return { ...prevState, kpi: false, transactional: false }
      })
      setTimeout(() => {
        setShowProgressBar(false)
      }, 2000)
      message.success(t('UPDATE_INFORMATION_MESSAGE'), 8)
    })
  }

  const reloadTablePercentage = () => {
    setShowAlert((prevState) => {
      return { ...prevState, percentage: true }
    })
    fetchDataRdnPercentageByPlanning({
      concept_id: budgetInstanceDetail?.concept_id,
      page: tablePagination.page,
      period_id: periodId,
      planning_id: budgetId,
      step: dataPhase.key,
      business_rule_id: businessRuleId,
    }).then(() => {
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
    })
  }

  const onClose = () => {
    setIsDeletingAll(false)
    setShowDeleteAll(false)
  }

  const onChangeTypeOfLoad = (e) => {
    setValue(e.target.value)
  }

  const handleClose = () => {
    setShowDrawerTools(false)
    if (applyRule) {
      console.log('applyRule', applyRule)
      reloadTableNested()
    }
    setApplyRule(false)
  }

  const handleApplyRule = (ruleId) => {
    setApplyRule(true)

    return applyBudgetRule(budgetId, ruleId, {
      concept_id: budgetInstanceDetail?.concept_id,
      period_id: periodId,
      step: budgetInstanceDetail?.step,
    })
  }

  const handleUnApplyRule = (ruleId) => {
    setApplyRule(true)

    return unApplyBudgetRule(budgetId, ruleId, {
      concept_id: budgetInstanceDetail?.concept_id,
      period_id: periodId,
      step: budgetInstanceDetail?.step,
    })
  }

  const onHandleActivity = () => {
    return `/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}/${dataPhase.key}/workflow/${budgetId}?type=planning&keyExecution=${budgetId}-${dataPhase.key}`
  }

  const handleSaveFilterSliders = () => {
    const data = {
      ...filters,
      ...sliderValue,
      ...selectedDates,
      step: dataPhase.key,
      planning_id: budgetId,
      ...((!filters.currency_id || filters.currency_id.length === 0) && {
        currency_id: defaultCurrencyData?.id,
      }),
    }

    setIsSaving(true)
    setFiltersSliders(data)
      .then(() => {
        reloadTableNested()
        message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
        setIsSaving(false)
        setFilters({})
        setSelectedDates({})
        setSliderValue({
          price_percentage_increase: 0,
          quantity_percentage_increase: 0,
          amount_percentage_increase: 0,
        })
        sendUserDataToGTM(loggedUser, 'Planificación', 'Aplicar sliders presupuesto', 'Aplicación')
      })
      .catch((error) => {
        setIsSaving(false)
        setFilters({})
        setSelectedDates({})
        setSliderValue({
          price_percentage_increase: 0,
          quantity_percentage_increase: 0,
          amount_percentage_increase: 0,
        })
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const handleExitConfirm = () => {
    if (lastLocation) {
      setShowExitModal(false)
      history.push(lastLocation)
      setShowAlert({
        kpi: false,
        transactional: false,
        percentage: false,
        createTransaction: false,
        send: false,
        rule: false,
        create: false,
      })
    } else {
      history.push(`/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}`)
    }
  }

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation) {
      setShowExitModal(true)
      setLastLocation(nextLocation)
      setConfirmedNavigation(true)
      setShowAlert({
        kpi: false,
        transactional: false,
        percentage: false,
        createTransaction: false,
        send: false,
        rule: false,
        create: false,
      })
      return false
    } else {
      setShowAlert({
        kpi: false,
        transactional: false,
        percentage: false,
        createTransaction: false,
        send: false,
        rule: false,
        create: false,
      })
      return true
    }
  }

  const handleOnClickCompartir = () => {
    const dataSettings = {
      ...(tabKey === 'transactional' && {
        ...settingsNested,
      }),
      ...(tabKey === 'percentage' && {
        ...settingsPercentage,
      }),
    }

    const {
      aggregatorName,
      cols,
      columns,
      default_format,
      default_value,
      rendererName,
      vals,
      valueFilter,
      rows,
    } = dataSettings

    const dataTable = {
      ...(!_.isEmpty(dataSettings) && {
        aggregatorName,
        cols,
        columns,
        default_format,
        default_value,
        rendererName,
        vals,
        valueFilter,
        rows,
      }),
    }

    const urlObj = new URL(window.location.href)
    const pathAndQuery = urlObj.pathname + urlObj.search

    shareLayout('planning', `${budgetId}-${dataPhase.key}`, {
      path: pathAndQuery,
      config: { ...dataTable },
    })
      .then((response) => {
        message.success(t('FEEDBACK_COPY_URL_SUCCESS'), 8)
        const newUrl = response.payload.data.url_hash
        // .replace(
        //   'https://stg.getplika.com/',
        //   'http://localhost:3000/',
        // )
        navigator.clipboard.writeText(newUrl)
      })
      .catch((error) => {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  return (
    <div>
      <Prompt
        when={
          showAlert.kpi ||
          showAlert.transactional ||
          showAlert.percentage ||
          showAlert.createTransaction ||
          showAlert.send ||
          showAlert.rule ||
          showAlert.create
        }
        message={handleBlockedNavigation}
      />
      <Row gutter={[24, 12]}>
        <Col span={24}>
          {/* KPIs and actions share one row; without KPIs the bar keeps the full width */}
          <Row gutter={[24, 12]} align="middle">
            {enableKpis && (
              <Col flex="auto">
                <PhaseKpis
                  kpiLoading={isKpisLoading || isDisable}
                  dataKpis={budgetKPIS}
                  userDetail={loggedUser}
                  setData={setData}
                  comments={data}
                  onRefetchComments={() => fetchCommentsList({ module: `${key}-${dataPhase.key}` })}
                  loading={isLoading}
                  phase={dataPhase.key}
                />
              </Col>
            )}
            <Col flex={enableKpis ? 'none' : 'auto'}>
              <UserActionsPhases
                onConfirmPopConfirm={() => {
                  setShowPopConfirmSend(false)
                  renderFunctionSend({
                    step: budgetInstanceDetail?.step,
                    setILoading: setIsDataLoading,
                    setNextPhase: () => setNextPhase({ planning_id: budgetId, status_budget }),
                    closing: () => closingBudget({ planning_id: budgetId, is_closing: true }),
                    onRefetch,
                    onClose: () => setIsDataLoading(false),
                    setShowAlert,
                    sendUserDataToGTM: () =>
                      sendUserDataToGTM(
                        loggedUser,
                        'Planificación',
                        'Enviar etapa siguiente presupuesto',
                        'Envío',
                      ),
                  })
                }}
                onCancelPopconfirm={() => setShowPopConfirmSend(false)}
                showPopConfirmSend={showPopConfirmSend}
                onClickSend={() => setShowPopConfirmSend(true)}
                buttonName={renderButtonSendName({
                  step: budgetInstanceDetail?.step,
                  dataPhasekey: dataPhase.key,
                  is_closing: budgetInstanceDetail?.is_closing,
                  buttonName: dataPhase.buttonName,
                })}
                disabled={
                  isFinished || budgetInstanceDetail?.is_closing || !canUserABM || isDisable
                }
                dataPhase={dataPhase}
                loading={isDataLoading}
                is_closing={budgetInstanceDetail?.is_closing}
                buttonUploadData={
                  <Button.PrimaryGhost
                    onClick={() => setShowUploadModal(true)}
                    disabled={
                      isFinished ||
                      budgetInstanceDetail?.is_closing ||
                      !canUserABM ||
                      isDataLoading ||
                      isDisable
                    }
                    title="ACTION_UPLOAD_DATA"
                  />
                }
                onClickActivity={() =>
                  history.push(
                    `/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}/${budgetId}/${dataPhase.key}/${tabKey}/actividad?type=planning&module=planningDetail`,
                  )
                }
                onClickApply={() => setShowDrawerTools(true)}
                loadingDelete={isDeletingAll}
                visible={showDeleteAll}
                onCancelDeleteAll={() => setShowDeleteAll(false)}
                onConfirmDeleteAll={() =>
                  handleDeleteAll({
                    setIsLoading: setIsDeletingAll,
                    deleteAll: () => deleteAllTransaction(budgetId, dataPhase.key),
                    onRefetch: () =>
                      fetchDataNestedTableByPhase({
                        step: dataPhase.key,
                        period_id: periodId,
                        concept_id: budgetInstanceDetail?.concept_id,
                        planning_id: budgetId,
                        page: tablePagination.page,
                      }),
                    onClose,
                    sendUserDataToGTM: () =>
                      sendUserDataToGTM(
                        loggedUser,
                        'Planificación',
                        'Eliminar todo presupuesto',
                        'Eliminación',
                      ),
                  })
                }
                onClickDeleteAll={() => setShowDeleteAll(true)}
                onClickCreate={() => setShowCreateModal(true)}
                hasCreate={canUserABM}
                extraButtons={{
                  module_name: 'planning',
                  concept: budgetInstanceDetail?.concept_id,
                  submodule_name: budgetId,
                }}
                type="planning"
                module="planning"
                isDisable={isDisable}
                onClickUpload={() => history.push(onHandleActivity())}
                onClickCompartir={() => handleOnClickCompartir()}
              />
            </Col>
          </Row>
        </Col>
        {enableSliders && (
          <Col span={24}>
            <FiltersSlidersKpis
              dataPeriod={dataPeriod}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              periodId={periodId}
              filters={filters}
              setFilters={setFilters}
              setSliderValue={setSliderValue}
              sliderValue={sliderValue}
              dataDimensions={dataDimensions}
              handleOnClick={handleSaveFilterSliders}
              isSaving={isSaving}
              disabled={isFinished || budgetInstanceDetail?.is_closing || !canUserABM || isDisable}
              setDataDimensions={setDataDimensions}
            />
          </Col>
        )}
        <Col span={24}>
          <TabsTables
            tabKey={tabKey}
            setTabKey={setTabKey}
            canUserABM={canUserABM}
            isDisable={isDisable}
            budgetInstanceDetail={budgetInstanceDetail}
            onConfirmDeletSelection={() => handleDeleteSelection()}
            isDataLoading={isDataLoading}
            dataPhase={dataPhase}
            dataPeriod={dataPeriod}
            isTableNestedLoading={isTableNestedLoading || isDisable}
            reloadTableNested={reloadTableNested}
            isFinished={isFinished}
            businessRuleId={businessRuleId}
            setBusinessRuleId={setBusinessRuleId}
            setRuleTypeValue={setRuleTypeValue}
            ruleTypeValue={ruleTypeValue}
            reloadTablePercentage={reloadTablePercentage}
            setData={setData}
            comments={data}
            onRefetchComments={() => fetchCommentsList({ module: `${key}-${dataPhase.key}` })}
            loading={isLoading}
            showProgressBar={showProgressBar}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            setShowAlert={setShowAlert}
            settingsNested={settingsNested}
            setSettingsNested={setSettingsNested}
            settingsPercentage={settingsPercentage}
            setSettingsPercentage={setSettingsPercentage}
          />
        </Col>
      </Row>
      <CreateBudgetModal
        title={t('PLANNING_CREATE_NEW_BUDGET_BASE_MODAL_TITLE')}
        nameButton={t('ACTION_UPLOAD')}
        visible={showUploadModal}
        concept={{ name: budgetInstanceDetail?.concept_name, id: budgetInstanceDetail?.concept_id }}
        onCancel={() => setShowUploadModal(false)}
        actionProjection={updateBudgetInstance}
        actionSpreadsheets={uploadSpreadsheets}
        onRefetchProjections={reloadTableNested}
        dataPeriod={dataPeriod}
        fileName={'PLANNING_TEMPLATE_NAME'}
        projectionInstanceList={budgetInstanceList}
        extraProps={{
          step: budgetInstanceDetail?.step,
          planning_id: budgetId,
        }}
        enabledTypeOfLoad={true}
        setIsDisable={setIsDisable}
        dataProjection={{
          id: budgetId,
          module: 'planning',
        }}
        uploadPlanningExcelFile={uploadPlanningExcelFileBy}
        setShowAlert={setShowAlert}
        type="upload"
        sendUserDataToGTM={() =>
          sendUserDataToGTM(loggedUser, 'Planificación', 'Cargar presupuesto', 'Carga')
        }
      />
      <ToolsDrawer
        onRefetchDataTable={reloadTableNested}
        visible={showDrawerTools}
        onClose={() => handleClose()}
        globalProjectionId={budgetId}
        type="planning"
        onRefetchRules={onRefetch}
        applyRule={(ruleId) => handleApplyRule(ruleId)}
        unApplyRule={(ruleId) => handleUnApplyRule(ruleId)}
        disabledRule={isFinished || budgetInstanceDetail?.is_closing || !canUserABM || isDisable}
        typeModule={GENERAL.MODULES_KEYS.MODULE_PLANNING}
        moduleId={budgetId}
        periodId={periodId}
        hasRule={true}
        extraParams={{
          status_budget: dataPhase.key,
        }}
        setShowAlert={setShowAlert}
        applyUnappluMassive={applyUnappluMassivePlanning}
        extraDataApplyUnapply={{
          card_id: budgetId,
          step: dataPhase.key,
        }}
        setApplyRuleB={setApplyRule}
      />
      <CreateTransactionModal
        title={t('ACTION_CREATE_TRANSACTION')}
        dataPeriod={dataPeriod}
        visible={showCreateModal}
        onCancel={() => setShowCreateModal(false)}
        onRefetch={reloadTableNested}
        onCreateTransaction={(values) =>
          massiveCreatePlanningTransaction({
            ...values,
            period_id: periodId,
            concept_id: budgetInstanceDetail?.concept_id,
            type_sync_data: value,
            planning_id: budgetId,
          })
        }
        onChangeTypeOfLoad={onChangeTypeOfLoad}
        typeOfLoad={value}
        setShowAlert={setShowAlert}
        sendUserDataToGTM={() =>
          sendUserDataToGTM(
            loggedUser,
            'Planificación',
            'Crear transacción presupuesto',
            'Creación',
          )
        }
      />
      <CreationExitModal
        visible={showExitModal}
        onClose={() => {
          setShowExitModal(false)
          setConfirmedNavigation(false)
          setShowAlert({
            kpi: false,
            transactional: false,
            percentage: false,
            createTransaction: false,
            send: false,
            rule: false,
            create: false,
          })
        }}
        onConfirm={handleExitConfirm}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  budgetKPIS: planning.selectors.getBudgetKpis(state),
  budgetInstanceList: planning.selectors.getBudgetInstanceList(state),
  periodList: planning.selectors.getPeriodList(state),
  currencyList: configuration.selectors.getCurrencyList(state),
  loggedUser: login.selectors.getWhoAmI(state),
  commentsList: configuration.selectors.getCommentsList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
})

const mapDispatchToProps = {
  setNextPhase: planning.actions.setNextPhase,
  closingBudget: planning.actions.closingBudget,
  fetchBudgetKpis: planning.actions.fetchBudgetKpis,
  fetchBudgetInstanceList: planning.actions.fetchBudgetInstanceList,
  updateBudgetInstance: planning.actions.updateBudgetInstance,
  fetchDataNestedTableByPhase: planning.actions.fetchDataNestedTableByPhase,
  uploadSpreadsheets: home.actions.uploadSpreadsheets,
  applyBudgetRule: planning.actions.applyBudgetRule,
  unApplyBudgetRule: planning.actions.unApplyBudgetRule,
  massiveCreatePlanningTransaction: planning.actions.massiveCreatePlanningTransaction,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,

  fetchDataRdnPercentageByPlanning: planning.actions.fetchDataRdnPercentageByPlanning,
  fetchRulesList: configuration.actions.fetchRulesList,
  deleteAllTransaction: planning.actions.deleteTransactionFilterByPlanning,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  uploadPlanningExcelFileBy: planning.actions.uploadPlanningExcelFileBy,
  setFiltersSliders: planning.actions.setFiltersSliders,
  applyUnappluMassivePlanning: planning.actions.applyUnappluMassivePlanning,
  shareLayout: control.actions.shareLayout,
}

BaseBudget.propTypes = {
  fetchDataRdnPercentageByPlanning: PropTypes.func,
  fetchRulesList: PropTypes.func,
  deleteAllTransaction: PropTypes.func,
  loggedUser: PropTypes.object,
  fetchCommentsList: PropTypes.func,
  commentsList: PropTypes.array,
  uploadPlanningExcelFileBy: PropTypes.func,
  allDimensionsList: PropTypes.array,
  setFiltersSliders: PropTypes.func,
  showTableqp: PropTypes.bool,
  setShowTableqp: PropTypes.func,
  dataPhase: PropTypes.shape({
    key: PropTypes.any,
    buttonName: PropTypes.string,
  }),
  tablePagination: PropTypes.shape({
    page: PropTypes.number,
  }),
  budgetInstanceDetail: PropTypes.shape({
    concept_id: PropTypes.number,
    step: PropTypes.string,
    concept_name: PropTypes.string,
    is_closing: PropTypes.bool,
  }),
  periodList: PropTypes.array,
  applyUnappluMassivePlanning: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseBudget)
